import React from "react";
import CategoryDescription from "../../components/categoryDescription";
import { ISectionCSS } from "../../models/interface/ISectionCSS";

const ProductCategoryHeader = (props: any) => {
  const { sectionItem } = props;

  const colorStyle: ISectionCSS = {
    "--backgroundColor": sectionItem.background_color
      ? sectionItem.background_color
      : "#0c3b5d",
    "--subBackgroundColor": sectionItem.sub_background_color
      ? sectionItem.sub_background_color
      : "#fff",
  };

  return (
    <div style={colorStyle} className="kd-product-category-header">
      <CategoryDescription
        {...props}
        isNeedScrollTrigger={false}
        isShowHome={false}
      />
    </div>
  );
};

export default ProductCategoryHeader;
